import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DrawerService } from 'src/app/core/services/drawer.service';
import { StockService } from '../../services/stock.service';
import { DRAWER_DATA } from 'src/app/app.component';
import { StoreStockAndLot } from '../../interfaces/stock.interface';

enum EditOptionIds {
  OPTIONS = "options",
  QUANTITY = "modify-quantity",
  LOCATION = "modify-location",
  COST = "modify-cost",
  TRANSFER = "transfer-stock",

}

@Component({
  selector: 'app-edit-stock-drawer',
  templateUrl: './edit-stock-drawer.component.html',
  styleUrls: ['./edit-stock-drawer.component.scss']
})
export class EditStockDrawerComponent implements OnDestroy {
  EditOptionIds = EditOptionIds

  private readonly destroy$ = new Subject<void>();

  currentView: EditOptionIds = EditOptionIds.OPTIONS;
  isLoading = false;

  editOptions = [
    {
      id: EditOptionIds.QUANTITY,
      title: 'pages.stock.edit.modify_quantity',
      description: 'pages.stock.edit.modify_quantity_description',
      icon: 'stock'
    },
    {
      id: EditOptionIds.LOCATION,
      title: 'pages.stock.edit.modify_location',
      description: 'pages.stock.edit.modify_location_description',
      icon: 'stock'
    },
    {
      id: EditOptionIds.COST,
      title: 'pages.stock.edit.modify_cost',
      description: 'pages.stock.edit.modify_cost_description',
      icon: 'edit-icon'
    },
    {
      id: EditOptionIds.TRANSFER,
      title: 'pages.stock.edit.transfer_stock',
      description: 'pages.stock.edit.transfer_stock_description',
      icon: 'arrow-up-right'
    }
  ];

  constructor(
    private readonly drawerService: DrawerService,
    private readonly stockService: StockService,
    private readonly dialog: MatDialog,
    @Inject(DRAWER_DATA) public data: StoreStockAndLot
  ) { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onOptionSelected(optionId: EditOptionIds): void {
    this.currentView = optionId;
  }

  onQuantityFormSubmitted(): void {
    this.drawerService.closeDrawer(true);
  }

  onLocationFormSubmitted(event: boolean): void {
    this.drawerService.closeDrawer(event);
  }

  onCostFormSubmitted(event: boolean): void {
    this.drawerService.closeDrawer(event);
  }

  onTransferFormSubmitted(): void {
    this.drawerService.closeDrawer(true);
  }

  goBack(): void {
    this.currentView = EditOptionIds.OPTIONS;
  }

  close(): void {
    this.drawerService.closeDrawer();
  }
} 